export const initialState = {
  homesCurrentValue: 0,
  mortgageOutstandingBalance: 0,
  desiredLoanAmount: 0,
  infoText: '',
  modalEstimate: false,
  liveState: null,
  loanAmountError: false,
  loanAmountErrorMessage: '',
  creditScore: 0,
  isCalculated: false,
  helocOutput: null,
  isLoading: false,
  modalInfoStatus: false,
  equityError: false,
}

export function helocReducer(state, action) {
  switch (action.type) {
    case 'SET_HOMES_CURRENT_VALUE':
      return { ...state, homesCurrentValue: action.payload }
    case 'SET_MORTGAGE_OUTSTANDING_BALANCE':
      return { ...state, mortgageOutstandingBalance: action.payload }
    case 'SET_DESIRED_LOAN_AMOUNT':
      return { ...state, desiredLoanAmount: action.payload }
    case 'SET_INFO_TEXT':
      return { ...state, infoText: action.payload }
    case 'SET_MODAL_ESTIMATE':
      return { ...state, modalEstimate: action.payload }
    case 'SET_LIVE_STATE':
      return { ...state, liveState: action.payload }
    case 'SET_LOAN_AMOUNT_ERROR':
      return { ...state, loanAmountError: action.payload }
    case 'SET_LOAN_AMOUNT_ERROR_MESSAGE':
      return { ...state, loanAmountErrorMessage: action.payload }
    case 'SET_CREDIT_SCORE':
      return { ...state, creditScore: action.payload }
    case 'SET_IS_CALCULATED':
      return { ...state, isCalculated: action.payload }
    case 'SET_HELOC_OUTPUT':
      return { ...state, helocOutput: action.payload }
    case 'SET_IS_LOADING':
      return { ...state, isLoading: action.payload }
    case 'SET_MODAL_INFO_STATUS':
      return { ...state, modalInfoStatus: action.payload }
    case 'SET_EQUITY_ERROR':
      return { ...state, equityError: action.payload }
    default:
      return state
  }
}
